<template>
  <div
    :class="{ 'is-hide': checkedCount === 0 }"
    class="boss-resumecheck-number-container"
  >
    <span class="boss-resumecheck-number">{{ checkedCount }}</span>
    <span class="boss-resumecheck-number-text">名チェックされています</span>
  </div>
</template>

<script>
export default {
  props: {
    checkedCount: {
      type: Number,
      default: 0
    }
  }
}
</script>
